import { render } from "./Admin.vue?vue&type=template&id=3ebc43ac&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=3ebc43ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ebc43ac"

export default script